import { useState } from 'react';
import { useGeofenceViolations } from '../../hooks/useGeofenceViolations.js';

// Admin/foreman review of denied clock-in attempts. One row per violation;
// columns: when, crew member, foreman actor (if any), job, distance,
// allowed radius, source (ui vs foreman).
//
// Default range = last 7 days. Date inputs are yyyy-mm-dd local; we
// convert to UTC ms for the API.
export default function GeofencePage() {
  const [days, setDays] = useState(7);
  const to = Date.now();
  const from = to - days * 86400000;
  const { data: violations = [], isLoading } = useGeofenceViolations({ from, to });

  return (
    <div>
      <div className="range-bar">
        <select className="field-select" value={days} onChange={e => setDays(Number(e.target.value))}>
          <option value={1}>Last 24 hours</option>
          <option value={7}>Last 7 days</option>
          <option value={30}>Last 30 days</option>
          <option value={90}>Last 90 days</option>
        </select>
        <span style={{ color: 'var(--warm-gray)', fontSize: 11 }}>{violations.length}</span>
      </div>
      {isLoading ? (
        <div className="loading">Loading…</div>
      ) : violations.length === 0 ? (
        <div className="loading">No geofence violations in this window. ✓</div>
      ) : (
        <table className="tbl">
          <thead>
            <tr>
              <th>When</th>
              <th>Crew</th>
              <th>Actor</th>
              <th>Job</th>
              <th className="num">Distance</th>
              <th className="num">Allowed</th>
              <th>Source</th>
            </tr>
          </thead>
          <tbody>
            {violations.map(v => (
              <tr key={v.id}>
                <td>{new Date(v.at).toLocaleString()}</td>
                <td>{v.user_name}</td>
                <td>{v.actor_id && v.actor_id !== v.user_id ? v.actor_name : '—'}</td>
                <td>{v.job_name || '—'}</td>
                <td className="num">{formatMeters(v.distance_m)}</td>
                <td className="num">{formatMeters(v.allowed_m)}</td>
                <td><span className="badge">{v.source}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

function formatMeters(m) {
  if (m == null) return '—';
  if (m >= 1000) return `${(m / 1000).toFixed(2)} km`;
  return `${m} m`;
}
